/**
 * CopilotSuggestions — sugestões iniciais de conversa (TASK-21).
 *
 * Exibido no estado vazio (nenhuma mensagem), antes do usuário digitar.
 * Cada sugestão é um botão que aciona `onSelect`, preenchendo o composer
 * com o texto correspondente (Req 9.2).
 *
 * Referências: design.md §20.15, Req 9.2, TASK-21.
 */

import styles from "./Copilot.module.css";

// ---------------------------------------------------------------------------
// Sugestões canônicas (Req 9.2)
// ---------------------------------------------------------------------------

const SUGGESTIONS = [
  "Quais oportunidades estão paradas há mais de 30 dias?",
  "Resumo do pipeline desta semana",
  "Quais contas precisam de follow-up urgente?",
  "Atividades atrasadas dos últimos 7 dias",
] as const;

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

export interface CopilotSuggestionsProps {
  /** Chamado quando o usuário clica em uma sugestão. */
  onSelect(suggestion: string): void;
}

// ---------------------------------------------------------------------------
// Componente
// ---------------------------------------------------------------------------

/**
 * Grade de sugestões clicáveis para iniciar a conversa (Req 9.2 — estado vazio).
 */
export function CopilotSuggestions({ onSelect }: CopilotSuggestionsProps) {
  return (
    <div className={styles.suggestions} aria-label="Sugestões de perguntas">
      <p className={styles.suggestionsLabel}>Experimente perguntar:</p>
      <ul className={styles.suggestionsList} role="list">
        {SUGGESTIONS.map((s) => (
          <li key={s}>
            <button
              type="button"
              className={styles.suggestionItem}
              onClick={() => onSelect(s)}
            >
              {s}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
